import React, { useEffect, useRef, useState } from "react";
import { cborTest } from "../../services/userService";
import * as cbor from "cbor-web";

interface Props {
  channelIndex?: number; // 기본은 0채널
}

export default function CBORImageViewer({ channelIndex = 0 }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [mat, setMat] = useState<number[][][] | null>(null);
  const [inputChannel, setInputChannel] = useState(channelIndex);
  const [channels, setChannels] = useState<number[]>([]);
  const [decoded, setDecoded] = useState<any>(null);

  // CBOR 데이터 가져오기
  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await cborTest();
        setChannels(response["channels"] || []);
        if (response && response["6chan"]) {
          setMat(response["6chan"]);
        }
      } catch (error) {
        console.error("Error fetching CBOR data:", error);
      }
    };
    fetch();
  }, []);

  useEffect(() => {
    const fetchAndDecode = async () => {
      try {
        const res = await fetch("/cbor_test.cbor");
        const arrayBuffer = await res.arrayBuffer();
        const uint8Array = new Uint8Array(arrayBuffer);
        const result = cbor.decode(uint8Array);
        setDecoded(result);
      } catch (err) {
        console.error("CBOR 디코딩 에러:", err);
      }
    };

    fetchAndDecode();
  }, []);

  useEffect(() => {
    if (!mat || mat.length === 0) return;

    const height = mat.length;
    const width = mat[0].length;
    const canvas = canvasRef.current;
    if (!canvas) return;

    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const imageData = ctx.createImageData(width, height);

    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const pixel = mat[y][x];
        const value = pixel[inputChannel];
        const idx = (y * width + x) * 4;

        imageData.data[idx + 0] = value; // R
        imageData.data[idx + 1] = value; // G
        imageData.data[idx + 2] = value; // B
        imageData.data[idx + 3] = 255; // A
      }
    }

    ctx.putImageData(imageData, 0, 0);
  }, [inputChannel]);

  // useEffect(() => {
  //   if (!mat || mat.length === 0) return;

  //   const height = mat.length;
  //   const width = mat[0].length;
  //   const canvas = canvasRef.current;
  //   if (!canvas) return;

  //   canvas.width = width;
  //   canvas.height = height;

  //   const ctx = canvas.getContext("2d");
  //   if (!ctx) return;
  //   const channels = decoded.mat[0][0].length; // 보통 6
  //   const rows = 2;
  //   const cols = Math.ceil(channels / rows);
  //   const tileWidth = width;
  //   const tileHeight = height;

  //   canvasRef.current.width = tileWidth * cols;
  //   canvasRef.current.height = tileHeight * rows;

  //   for (let c = 0; c < channels; c++) {
  //     const imageData = ctx.createImageData(tileWidth, tileHeight);
  //     const data = imageData.data;

  //     for (let y = 0; y < tileHeight; y++) {
  //       for (let x = 0; x < tileWidth; x++) {
  //         const value = decoded.mat[y][x][c] ?? 0;
  //         const idx = (y * tileWidth + x) * 4;

  //         // 단일 채널을 흑백으로 렌더링
  //         data[idx] = value;
  //         data[idx + 1] = value;
  //         data[idx + 2] = value;
  //         data[idx + 3] = 255;
  //       }
  //     }

  //     // 위치 계산
  //     const dx = (c % cols) * tileWidth;
  //     const dy = Math.floor(c / cols) * tileHeight;
  //     ctx.putImageData(imageData, dx, dy);
  //   }
  // }, [inputChannel]);

  // useEffect(() => {
  //   if (!decoded || !decoded.mat) return;

  //   const [height, width] = decoded.sizeHWC;
  //   const ctx = canvasRef.current?.getContext("2d");
  //   if (!ctx) return;

  //   const channels = decoded.mat[0][0].length; // 예: 6채널
  //   const canvas = canvasRef.current;
  //   if (!canvas) return;
  //   // 캔버스 사이즈 설정: 가로는 채널 수만큼 곱
  //   canvas.width = width * channels;
  //   canvas.height = height;

  //   for (let c = 0; c < channels; c++) {
  //     const imageData = ctx.createImageData(width, height);
  //     const data = imageData.data;

  //     for (let y = 0; y < height; y++) {
  //       for (let x = 0; x < width; x++) {
  //         const value = decoded.mat[y][x][c] ?? 0;
  //         const idx = (y * width + x) * 4;

  //         data[idx] = value; // R
  //         data[idx + 1] = value; // G
  //         data[idx + 2] = value; // B
  //         data[idx + 3] = 255; // A
  //       }
  //     }

  //     // 가로 방향 위치 계산
  //     const dx = c * width;
  //     ctx.putImageData(imageData, dx, 0);
  //   }
  // }, [decoded]);

  return (
    <div>
      <p>
        채널 {inputChannel} 이미지:
        <input onChange={(e) => setInputChannel(Number(e.target.value))} />
      </p>
      <canvas
        ref={canvasRef}
        style={{ border: "1px solid #ccc", width: "400px" }}
      />
    </div>
  );
}
